<template>
  <div v-if="noteCount > 0">
    <a href="#" @click.prevent="show = !show" class="ms-2"
      >{{ caret }} {{ noteCount }} incomplete {{ noteCount == 1 ? "note" : "notes" }} from previous versions</a
    >
    <Notes
      v-show="show"
      hide-complete-option="true"
      hide-create="true"
      show-version="true"
      :notes="incompleteNotes"
      :owns-mix="ownsMix"
      :mid-id="mixId"
      :highlightedNote="highlightedNote"
      @play-at-time="$emit('play-at-time', $event)"
      @note-mouseenter="$emit('note-mouseenter', $event)"
      @note-mouseleave="$emit('note-mouseleave', $event)"
    />
  </div>
</template>

<script>
import Notes from "./notes.vue"

export default {
  props: ["notes", "mix-id", "owns-mix", "highlightedNote"],
  components: { Notes },
  data: function () {
    return { show: true }
  },
  computed: {
    caret() {
      return this.show ? "▼" : "▶"
    },
    noteCount() {
      return this.incompleteNotes.filter(n => !n.parent_note_id).length
    },
    incompleteNotes() {
      return this.notes.filter(n => !n.completed && !n.deleted)
    }
  },
}
</script>
